(() => {
  if (window.__olivineReeviewVeloInit) return;
  window.__olivineReeviewVeloInit = true;

  const EMPTY_CHECK_DELAY_MS = 12000;
  const INIT_RETRY_MS = 100;
  const INIT_MAX_ATTEMPTS = 100;
  const MIN_CONTENT_HEIGHT = 24;

  const boot = () => {
    const veloBlock = document.querySelector('[data-reeview-velo-block]');
    const widgetWrapper = veloBlock?.querySelector('.main-product-container-info-action-widget');
    const widget = veloBlock?.querySelector('.reeview-app-widget');
    if (!veloBlock || !widgetWrapper || !widget) return;

    const widgetId = veloBlock.dataset.reeviewWidgetId;
    const productId = veloBlock.dataset.productId;
    let hasResolvedEmpty = false;
    let initAttempts = 0;
    let resizeObserver = null;
    let observer = null;

    const isShellNode = (node) =>
      node === widget ||
      node === widgetWrapper ||
      (node?.classList?.contains('reeview-app-widget') && !node?.parentElement?.closest?.('.reeview-app-widget'));

    const nodeHasRenderableContent = (node) => {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
      if (isShellNode(node)) {
        if (node.shadowRoot?.childElementCount > 0) return true;
        return Array.from(node.children).some((child) => nodeHasRenderableContent(child));
      }

      if (
        node.matches?.(
          'iframe, video, img, canvas, svg, #vw-root, [class*="vw-"], [class*="vw-cmp"], [id*="vw-"], [class*="videowise"], [class*="Videowise"], [class*="reeview"], [id*="reeview"]'
        )
      ) {
        if (node.matches?.('img, video, canvas, iframe, svg')) {
          const rect = node.getBoundingClientRect?.();
          if (rect && rect.width > 0 && rect.height > 0) return true;
          if (node.offsetWidth > 0 || node.offsetHeight > 0) return true;
          // Media tag present (may still be measuring in the pending off-screen host)
          return true;
        }
        return true;
      }

      if (node.shadowRoot?.childElementCount > 0) return true;

      if (node.childElementCount > 0) {
        return Array.from(node.children).some((child) => nodeHasRenderableContent(child));
      }

      return Boolean(node.textContent?.trim().length);
    };

    const widgetHasContent = () => {
      if (Array.from(widget.children).some((child) => nodeHasRenderableContent(child))) {
        return true;
      }
      if (widget.shadowRoot?.childElementCount > 0) return true;
      if (
        Array.from(widgetWrapper.children).some(
          (child) => child !== widget && nodeHasRenderableContent(child)
        )
      ) {
        return true;
      }

      // El host pendiente mide off-screen (position: fixed); su altura sí cuenta.
      const measuredHeight = Math.max(
        widget.offsetHeight || 0,
        widget.scrollHeight || 0,
        widgetWrapper.offsetHeight || 0,
        widgetWrapper.scrollHeight || 0
      );
      if (measuredHeight > MIN_CONTENT_HEIGHT) return true;

      return false;
    };

    const cleanupObservers = () => {
      observer?.disconnect();
      observer = null;
      resizeObserver?.disconnect();
      resizeObserver = null;
    };

    const showVeloBlock = () => {
      hasResolvedEmpty = false;
      veloBlock.classList.remove('is-pending', 'is-empty');
      veloBlock.hidden = false;
      cleanupObservers();
    };

    const hideVeloBlock = () => {
      hasResolvedEmpty = true;
      veloBlock.classList.add('is-empty');
      veloBlock.classList.remove('is-pending');
      veloBlock.hidden = true;
      cleanupObservers();
    };

    const syncVeloVisibility = () => {
      if (widgetHasContent()) {
        showVeloBlock();
      }
    };

    const initVideowiseWidget = () => {
      if (!widgetId || !productId) return false;

      if (typeof window.initVideowiseBulk === 'function') {
        window.initVideowiseBulk({
          shop: window.Shopify?.shop,
          widgetIds: [widgetId],
          productId: String(productId),
        });
        return true;
      }

      if (typeof window.initVideowise === 'function') {
        window.initVideowise();
        return true;
      }

      return false;
    };

    const tryInitUntilReady = () => {
      if (initVideowiseWidget()) {
        syncVeloVisibility();
        return;
      }

      initAttempts += 1;
      if (initAttempts >= INIT_MAX_ATTEMPTS) return;
      setTimeout(tryInitUntilReady, INIT_RETRY_MS);
    };

    // No usar [hidden]/display:none) en pending: bloquea el montaje de Videowise.
    // Solo is-pending mantiene el bloque invisible pero medible.
    veloBlock.hidden = false;
    veloBlock.classList.add('is-pending');
    veloBlock.classList.remove('is-empty');

    syncVeloVisibility();
    tryInitUntilReady();

    observer = new MutationObserver(syncVeloVisibility);
    observer.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true });
    observer.observe(widgetWrapper, { childList: true, subtree: true, characterData: true, attributes: true });

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(syncVeloVisibility);
      resizeObserver.observe(widget);
      resizeObserver.observe(widgetWrapper);
    }

    [100, 250, 500, 1000, 2000, 4000, 8000, EMPTY_CHECK_DELAY_MS].forEach((delay) => {
      setTimeout(() => {
        if (hasResolvedEmpty || !veloBlock.classList.contains('is-pending')) return;
        initVideowiseWidget();
        syncVeloVisibility();
      }, delay);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && veloBlock.classList.contains('is-pending')) {
        initVideowiseWidget();
        syncVeloVisibility();
      }
    });

    setTimeout(() => {
      if (!veloBlock.classList.contains('is-pending')) return;
      if (!widgetHasContent()) {
        hideVeloBlock();
      } else {
        showVeloBlock();
      }
    }, EMPTY_CHECK_DELAY_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
